// extracted by mini-css-extract-plugin
export default {"location-container":"start-page-location_location-container__n+ZUj"};